var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "M57.956 10.232H38.62v16l-4.759-4.602-4.759 4.59v-16H17.035v61.635h40.921c2.888 0 5.231-2.232 5.231-4.985V15.218c0-2.756-2.343-4.986-5.23-4.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74CAFC",
    d: "M31.237 41.133c0-.99.802-1.79 1.79-1.79h21.27a1.79 1.79 0 0 1 0 3.581h-21.27a1.79 1.79 0 0 1-1.79-1.791m3.549 7.162c0-.99.801-1.79 1.79-1.79h14.17a1.79 1.79 0 0 1 0 3.581h-14.17a1.79 1.79 0 0 1-1.79-1.791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#268CC9",
    d: "M17.035 10.232h7.08v61.623h-7.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "M36.5 8.063h-7.594c-.563 0-1.102.23-1.5.636a2.2 2.2 0 0 0-.62 1.533h2.316v16l4.76-4.602 4.758 4.59v-16c-.005-1.193-.953-2.157-2.12-2.157"
  }))));
};
export default SvgBook;